import * as Sentry from "@sentry/react-native";
import {
  logEvent as firebaseLogEvent,
  getAnalytics,
  setAnalyticsCollectionEnabled,
  settings,
} from "firebase/analytics";
import { app } from "./firebaseApp.web";

settings({
  dataLayerName: "appDataLayer",
});

export const analytics = getAnalytics(app);

if (__DEV__) {
  setAnalyticsCollectionEnabled(analytics, false);
}

export const logEvent = async (
  eventName: string,
  eventParams?: Parameters<typeof firebaseLogEvent>[2],
  options?: Parameters<typeof firebaseLogEvent>[3],
) => {
  try {
    await firebaseLogEvent(analytics, eventName, eventParams, options);
  } catch (error) {
    console.error("Failed to log analytics event", error);
    Sentry.captureException(error);
  }
};
